import type { StateCreator } from "zustand/vanilla";
import { devtools, persist, subscribeWithSelector } from "zustand/middleware";
import { create } from "zustand/react";
import Env from "@/core/config/env";

export function createState<T>(
  name: string,
  initializer: StateCreator<T, [], [], T>,
  config?: {
    persist?: boolean;
    subscribe?: boolean;
    partialize?: (state: T) => Partial<T>;
  },
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let state: any = initializer;
  if (config?.subscribe) {
    state = subscribeWithSelector(state);
  }
  if (config?.persist) {
    state = persist(state, {
      name: `${name.toLowerCase()}-storage`,
      ...(config.partialize ? { partialize: config.partialize } : {}),
    });
  }
  if (Env.isDevelopment) {
    return create<T>()(devtools(state, { name, store: `$${name}Store` }));
  }
  return create<T>()(state);
}
